// The words on an Ask BigAgri answer's link button: "Open Runs", not "See the
// data" (F16 UF-15). The page's name is looked up by path in the module
// registry, so a renamed module renames its Ask link with it. A path the
// registry does not know (or a redirect route) gets "Open the page".

import { MODULES } from '@/lib/modules'

// Routes that are redirects into a hub tab: no module owns the path itself.
const REDIRECT_LABELS: Record<string, string> = {
  '/farm/spray-records': 'Spray records',
  '/farm/spray-tasks': 'Spray tasks',
}

const trimSlashes = (p: string) => p.replace(/\/+$/, '')

/** Does module path `p` own `clean` (the path itself or anything under it)? */
function owns(p: string, clean: string): boolean {
  return p !== '' && p !== '/' && (clean === p || clean.startsWith(`${p}/`))
}

/** The page name for an Ask link, or null when nothing is known about it. */
function askLinkPageName(path: string): string | null {
  const clean = trimSlashes(path.split(/[?#]/)[0])
  if (REDIRECT_LABELS[clean]) return REDIRECT_LABELS[clean]
  const owners = MODULES.filter(m => owns(trimSlashes(m.path), clean))
  owners.sort((a, b) => trimSlashes(b.path).length - trimSlashes(a.path).length)
  return owners[0]?.label ?? null
}

/** "Open Runs" / "Open Floor Monitor"; "Open the page" when unknown. */
export function askLinkLabel(path: string): string {
  const name = askLinkPageName(path)
  return name ? `Open ${name}` : 'Open the page'
}
